/* eslint-disable @typescript-eslint/camelcase */
import { takeLatest, call, put, takeEvery } from "redux-saga/effects";
import * as types from "src/types/actions";
import callApi from "./helpers";
import { apiAuthURI, apiGraphQLURI, apiNotificationURI } from "../env";
import moment from "moment";
import _ from "lodash";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const getAuthConfig = (params) => {
  return {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(params),
  };
};

const getGraphQLConfig = (params, query) => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.payload.token}`,
    },
    mode: "cors",
    method: "POST",
    body: JSON.stringify(query),
  };
};

const getGraphQLConfigGet = (params, query) => {
  return {
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${params.payload.token}`,
    },
    mode: "cors",
    method: "GET",
  };
};

const notificationConfig = (params, query) => {
  return {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "http://dev.io",
    },
    method: "POST",
    body: JSON.stringify(query),
  };
};

const santiseOptions = (options) => {
  return JSON.stringify(options.map((o) => ({ Code: o.Code, Qty: o.Qty.toString() }))).replace(
    /"([^"]+)":/g,
    "$1:"
  );
};

export function* checkinAuth(params) {
  const isAdditionalDriver = params.payload.isAdditionalDriver;
  const isNoResNo = params.payload.bookingNumber ? false : true;
  const authQuery = isAdditionalDriver ? {
    scope: "WEB_CHECK_IN",
    booking_id: params.payload.bookingNumber.substring(0, 10),
    isAdditionalDriver,
  } : isNoResNo ? {
    scope: "WEB_CHECK_IN",
    last_name: params.payload.lastName.toUpperCase(),
    country: params.payload.country,
    gold_number: params.payload.goldNo,
    pickup_date: params.payload.pickupDate,
    pickup_location: params.payload.pickupLoc,
  } : {
    scope: "WEB_CHECK_IN",
    booking_id: params.payload.bookingNumber.substring(0, 10),
    generic_checkin: params.payload.isGenericCheckin,
    last_name: params.payload.lastName.toUpperCase(),
    country: params.payload.country,
  };
  yield call(callApi, () => fetch(apiAuthURI, getAuthConfig(authQuery)), types.CHECKINAUTH, {
    ...params.payload,
  });
}



export function* additionalDriverAuth(params) {
  const authQuery = {
    scope: "WEB_CHECK_IN",
    isAdditionalDriver: true,
    booking_id: params.payload.bookingNumber.substring(0, 10),
  };
  yield call(callApi, () => fetch(apiAuthURI, getAuthConfig(authQuery)), types.ADDITIONAL_DRIVER_AUTH, {
    ...params.payload,
  });
}

export function* sendEmailNotification(params) {
  const query = {
    type: "Email",
    context: params.payload.context,
    name: params.payload.name,
    brand: params.payload.brand,
    estimate: params.payload.estimate,
    total: params.payload.total,
    resNo: params.payload.resNo,
    confNo: params.payload.confNo,
    pickupDate: params.payload.pickupDate,
    pickupTime: params.payload.pickupTime,
    pickupLocation: params.payload.pickupLocation,
    email: params.payload.email,
    LocationAddress: params.payload.LocationAddress,
    date: params.payload.date,
  };

  yield call(
    callApi,
    () => fetch(apiNotificationURI, notificationConfig(params, query)),
    types.SENDNOTIFICATION,
    {
      ...params.payload,
    }
  );
}

export function* checkin(params) {
  const checkInQuery = {
    query: `{
      FrontDeskSearchReservation{
          Success
          Surname
          ResNo
          ResType
          ConfNo
          Error
          Country
          LicenceNumber
          PrePaid,
          OtherID,
          VerifyID,
          VerifyCC,
          SmsSentToAddDriverSuccess,
          CheckinStatus,
          AdditionalDriverIdVerified
        }
      }`,
  };

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, checkInQuery)),
    types.CHECKIN,
    { ...params.payload }
  );
}

export function* checkinGeneric(params) {
  const Query = {
    query: `{
      GenericCheckinSearch{
          Success,
          Country,
          CheckinStatus,
          Brand,
          Error
        }
      }`,
  };
  yield call(callApi, () => fetch(apiGraphQLURI, getGraphQLConfig(params, Query)), types.CHECKIN_GENERIC, {
    ...params.payload
  });
}

export function* searchCustomer(params) {
  const searchQuery = {
    query: `{
      FrontdeskSearchCustomer(
        LicNo: "${params.payload.licNo}",
        Country : "${params.payload.country}",
        ResNumber:"${params.payload.resNo}",
        IsAdditionalDriver:${params.payload.isAdditionalDriver},
      ){
        LatestCustomer{
          customerNumber,
          RenterName{
            firstName,
            lastName,
          },
          Address{
            Street,
            City,
            PostalCode,
            Email,
            StateOrProvCode,
            HomeTelephoneNumber,
            CellTelephoneNumber
          },
          Gender,
          Title,
          BirthDate,
          PlaceOfBirth,
          CountryOfBirth,
          DrivingLicence{
            Number,
            Issuer,
            ExpiryDate
          },
          Type
        },
        IdVerification{
          resNumber,
          Verified,
          VerifiedTime,
          Channel,
          FlowType,
          TransactionId,
          Status
        }
        DNR,
        Success,
        Error
      }
    }`,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, searchQuery)),
    types.SEARCHCUSTOMER,
    { ...params.payload }
  );
}

const santiseEstimates = (estimate) => {
  estimate = _.filter(estimate, (e) => e != undefined);
  return JSON.stringify(
    estimate.map((e) => ({
      Description: e.Description,
      SubTotal: e.SubTotal.toString(),
      Quantity: e.Quantity.toString(),
    }))
  ).replace(/"([^"]+)":/g, "$1:");
};

export function* updateReservationAndCustomer(params) {
  const updateQuery = {
    query: ` mutation {
      FrontdeskUpdateReservationAndCustomer(
        ResNo: "${params.payload.resno}",
        MainNote: "${params.payload.MainNote}",
        Checkedin: true,
        ConfNo:"${params.payload.confNo}",
        PickupDate:"${params.payload.pickupDate}",
        PickupTime: "${params.payload.pickupTime}",
        PickupLocation: "${params.payload.pickupLocation}",
        LocationAddress: "${params.payload.locationAddress}",
        Date:"${params.payload.date}",
        Total: "${params.payload.total}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        OtherId:"${params.payload.otherid}"
        Prepaid:${params.payload.prepaid},
        Estimate:${santiseEstimates(params.payload.estimate)},
        Name: "${params.payload.name}"
        Renter: {
          IdVerificationSkipped: ${params.payload.idVerificationSkipped},
          CustomerNumber : "${params.payload.CustomerNumber}"
          FirstName: "${params.payload.data.firstName.slice(0,12).toUpperCase()}",
          LastName: "${params.payload.data.lastName.slice(0,18).toUpperCase()}",
          BirthDate: "${moment(params.payload.data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          Address: {
            CellTelephoneNumber:"${params.payload.data.emergencyContactNumber}",
            HomeTelephoneNumber:"${params.payload.data.contactNumber}",
            Email:"${params.payload.data.email.toUpperCase().trim()}",
            PostalCode:"${params.payload.data.postalCode.trim()}"
            Street: ["${params.payload.data.street1
      }","${params.payload.data.street2.toUpperCase()}"],
            City: "${params.payload.data.city.toUpperCase().slice(0,16)}",
            CountryCode: "${params.payload.data.countryCode == "AC" ||
                            params.payload.data.countryCode == "NS" ||
                            params.payload.data.countryCode == "NT" ||
                            params.payload.data.countryCode == "QL" ||
                            params.payload.data.countryCode == "SA" ||
                            params.payload.data.countryCode == "TS" ||
                            params.payload.data.countryCode == "VI" ||
                            params.payload.data.countryCode == "WA"
                            ? "AU"
                            : params.payload.data.countryCode
                          }",
            StateOrProvCode: "${params.payload.data.countryCode}"
          },
          DrivingLicence: {
            Number: "${params.payload.data.licenceNo.toUpperCase()}",
            Issuer: "${params.payload.data.regionOfIssue}",
            ExpiryDate: "${moment(params.payload.data.expiry, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          },
          IDStatus: {
            Scanned: true,
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.UPDATERESERVATIONANDCUSTOMER,
    { ...params.payload }
  );
}

export function* createNewCustomer(params) {
  const updateQuery = {
    query: ` mutation {
      FrontdeskCreateCustomer(
        ResNo: "${params.payload.resno}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        Renter: {
          IsAdditionalDriver: true,
          IdVerificationSkipped: ${params.payload.idVerificationSkipped},
          FirstName: "${params.payload.data.firstName.slice(0,12).toUpperCase()}",
          LastName: "${params.payload.data.lastName.slice(0,18).toUpperCase()}",
          BirthDate: "${moment(params.payload.data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          Address: {
            CellTelephoneNumber:"${params.payload.data.emergencyContactNumber}",
            HomeTelephoneNumber:"${params.payload.data.contactNumber}",
            Email:"${params.payload.data.email.toUpperCase().trim()}",
            PostalCode:"${params.payload.data.postalCode.trim()}"
            Street: ["${params.payload.data.street1
      }","${params.payload.data.street2.toUpperCase()}"],
            City: "${params.payload.data.city.toUpperCase().slice(0,16)}",
            CountryCode: "${params.payload.data.countryCode == "AC" ||
        params.payload.data.countryCode == "NS" ||
        params.payload.data.countryCode == "NT" ||
        params.payload.data.countryCode == "QL" ||
        params.payload.data.countryCode == "SA" ||
        params.payload.data.countryCode == "TS" ||
        params.payload.data.countryCode == "VI" ||
        params.payload.data.countryCode == "WA"
        ? "AU"
        : params.payload.data.countryCode
      }",
            StateOrProvCode: "${params.payload.data.countryCode}"
          },
          DrivingLicence: {
            Number: "${params.payload.data.licenceNo.toUpperCase()}",
            Issuer: "${params.payload.data.regionOfIssue}",
            ExpiryDate: "${moment(params.payload.data.expiry, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          },
          IDStatus: {
            Scanned: ${params.payload.data.scanDocPass},
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
        CustomerNumber
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.CREATE_CUSTOMER,
    { ...params.payload }
  );
}

export function* updateCustomer(params) {
  const updateQuery = params.payload.data.scanDocPass? {
    query: ` mutation {
      FrontdeskUpdateCustomer(
        ResNo: "${params.payload.resno}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        CustomerNumber : "${params.payload.CustomerNumber}",
        Renter: {
          IdVerificationSkipped: ${params.payload.idVerificationSkipped},
          IsAdditionalDriver: ${params.payload.isAdditionalDriver},
          FirstName: "${params.payload.data.firstName?.slice(0,12).toUpperCase()}",
          LastName: "${params.payload.data.lastName?.slice(0,18).toUpperCase()}",
          BirthDate: "${moment(params.payload.data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          Address: {
            CellTelephoneNumber:"${params.payload.data.emergencyContactNumber}",
            HomeTelephoneNumber:"${params.payload.data.contactNumber}",
            Email:"${params.payload.data.email?.toUpperCase().trim()}",
            PostalCode:"${params.payload.data.postalCode.trim()}"
            Street: ["${params.payload.data.street1
      }","${params.payload.data.street2.toUpperCase()}"],
            City: "${params.payload.data.city.toUpperCase().slice(0,16)}",
            CountryCode: "${params.payload.data.countryCode == "AC" ||
        params.payload.data.countryCode == "NS" ||
        params.payload.data.countryCode == "NT" ||
        params.payload.data.countryCode == "QL" ||
        params.payload.data.countryCode == "SA" ||
        params.payload.data.countryCode == "TS" ||
        params.payload.data.countryCode == "VI" ||
        params.payload.data.countryCode == "WA"
        ? "AU"
        : params.payload.data.countryCode
      }",
            StateOrProvCode: "${params.payload.data.countryCode}"
          },
          DrivingLicence: {
            Number: "${params.payload.data.licenceNo.toUpperCase()}",
            Issuer: "${params.payload.data.regionOfIssue}",
            ExpiryDate: "${moment(params.payload.data.expiry, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          },
          IDStatus: {
            Scanned: ${params.payload.data.scanDocPass},
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
        CustomerNumber
      }
    }
   
  `,
  }:{
    query: ` mutation {
      FrontdeskUpdateCustomer(
        ResNo: "${params.payload.resno}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        CustomerNumber : "${params.payload.CustomerNumber}",
        Renter: {
          IdVerificationSkipped: ${params.payload.idVerificationSkipped},
          IsAdditionalDriver: ${params.payload.isAdditionalDriver},
          IDStatus: {
            Scanned: ${params.payload.data.scanDocPass},
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
        CustomerNumber
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.UPDATE_CUSTOMER,
    { ...params.payload }
  );
}

export function* manualCreateNewCustomer(params) {
  const updateQuery = {
    query: ` mutation {
      FrontdeskCreateCustomer(
        ResNo: "${params.payload.resno}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        Renter: {
          IsAdditionalDriver: true
          FirstName: "${params.payload.data.firstName.slice(0,12).toUpperCase()}",
          LastName: "${params.payload.data.lastName.slice(0,18).toUpperCase()}",
          BirthDate: "${moment(params.payload.data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          Address: {
            CellTelephoneNumber:"${params.payload.data.emergencyContactNumber}",
            HomeTelephoneNumber:"${params.payload.data.contactNumber}",
            Email:"${params.payload.data.email?.toUpperCase().trim()}",
            PostalCode:"${params.payload.data.postalCode.trim()}"
            Street: ["${params.payload.data.street1
      }","${params.payload.data.street2.toUpperCase()}"],
            City: "${params.payload.data.city.toUpperCase().slice(0,16)}",
            CountryCode: "${params.payload.data.countryCode == "AC" ||
        params.payload.data.countryCode == "NS" ||
        params.payload.data.countryCode == "NT" ||
        params.payload.data.countryCode == "QL" ||
        params.payload.data.countryCode == "SA" ||
        params.payload.data.countryCode == "TS" ||
        params.payload.data.countryCode == "VI" ||
        params.payload.data.countryCode == "WA"
        ? "AU"
        : params.payload.data.countryCode
      }",
            StateOrProvCode: "${params.payload.data.countryCode}"
          },
          DrivingLicence: {
            Number: "${params.payload.data.licenceNo.toUpperCase()}",
            Issuer: "${params.payload.data.regionOfIssue}",
            ExpiryDate: "${moment(params.payload.data.expiry, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          },
          IDStatus: {
            Scanned: true,
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
        CustomerNumber
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.MANUAL_CREATE_CUSTOMER,
    { ...params.payload }
  );
}

export function* manualUpdateCustomer(params) {
  const updateQuery = params.payload.data.scanDocPass? {
    query: ` mutation {
      FrontdeskUpdateCustomer(
        ResNo: "${params.payload.resno}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        CustomerNumber : "${params.payload.CustomerNumber}",
        Renter: {
          IsAdditionalDriver: true,
          FirstName: "${params.payload.data.firstName?.slice(0,12).toUpperCase()}",
          LastName: "${params.payload.data.lastName?.slice(0,18).toUpperCase()}",
          BirthDate: "${moment(params.payload.data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          Address: {
            CellTelephoneNumber:"${params.payload.data.emergencyContactNumber}",
            HomeTelephoneNumber:"${params.payload.data.contactNumber}",
            Email:"${params.payload.data.email?.toUpperCase().trim()}",
            PostalCode:"${params.payload.data.postalCode.trim()}"
            Street: ["${params.payload.data.street1
      }","${params.payload.data.street2.toUpperCase()}"],
            City: "${params.payload.data.city.toUpperCase().slice(0,16)}",
            CountryCode: "${params.payload.data.countryCode == "AC" ||
        params.payload.data.countryCode == "NS" ||
        params.payload.data.countryCode == "NT" ||
        params.payload.data.countryCode == "QL" ||
        params.payload.data.countryCode == "SA" ||
        params.payload.data.countryCode == "TS" ||
        params.payload.data.countryCode == "VI" ||
        params.payload.data.countryCode == "WA"
        ? "AU"
        : params.payload.data.countryCode
      }",
            StateOrProvCode: "${params.payload.data.countryCode}"
          },
          DrivingLicence: {
            Number: "${params.payload.data.licenceNo.toUpperCase()}",
            Issuer: "${params.payload.data.regionOfIssue}",
            ExpiryDate: "${moment(params.payload.data.expiry, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          },
          IDStatus: {
            Scanned: ${params.payload.data.scanDocPass},
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
        CustomerNumber
      }
    }
   
  `,
  }:{
    query: ` mutation {
      FrontdeskUpdateCustomer(
        ResNo: "${params.payload.resno}",
        Brand:"${params.payload.brand}",
        Country:"${params.payload.country}",
        CustomerNumber : "${params.payload.CustomerNumber}",
        Renter: {
          IDStatus: {
            Scanned: ${params.payload.data.scanDocPass},
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
        CustomerNumber
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.MANUAL_UPDATE_CUSTOMER,
    { ...params.payload }
  );
}

export function* manualUpdateReservationAndCustomerFromIdvResult(params) {
  const updateQuery = {
    query: ` mutation {
      FrontdeskUpdateReservationAndCustomer(
        ResNo: "${params.payload.resno}",
        Country:"${params.payload.country}",
        OtherId:"${params.payload.otherid}",
        Checkedin: false,
        MainNote: "${params.payload.MainNote}",
        Renter: {
          BirthDate: "${moment(params.payload.data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          FirstName: "${params.payload.data.firstName.slice(0,12).toUpperCase()}",
          LastName: "${params.payload.data.lastName.slice(0,18).toUpperCase()}",
          CustomerNumber : "${params.payload.CustomerNumber}",
          Address: {
            CellTelephoneNumber:"${params.payload.data.emergencyContactNumber}",
            HomeTelephoneNumber:"${params.payload.data.contactNumber}",
            Email:"${params.payload.data.email?.toUpperCase().trim()}",
            PostalCode:"${params.payload.data.postalCode?.trim()}",
            Street: ["${params.payload.data.street1
      }","${params.payload.data.street2?.toUpperCase()}"],
            City: "${params.payload.data.city?.toUpperCase().slice(0,16)}",
            StateOrProvCode: "${params.payload.data.countryCode}"
          },
          DrivingLicence: {
            Number: "${params.payload.data.licenceNo?.toUpperCase()}",
            Issuer: "${params.payload.data.regionOfIssue}",
            ExpiryDate: "${moment(params.payload.data.expiry, "DD-MM-YYYY").format("YYYY-MM-DD")}",
          },
          IDStatus: {
            Scanned: true,
            Date: "${moment(params.payload.data.verifiedTime, "YYYY-MM-DD").format("YYYY-MM-DD")}",
            },
        },
      ){
        Success
        Errors
        Messages
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.MANUAL_UPDATERESERVATIONANDCUSTOMER,
    { ...params.payload }
  );
}


export function* updateReservationAndCustomerCIF(params) {
  const updateQuery = {
    query: ` mutation {
      FrontdeskUpdateReservationAndCustomer(
        ResNo: "${params.payload.resno}",
        Checkedin:  ${params.payload.CheckedIn},
        CheckinFailed:  ${params.payload.CheckinFailed},
        FailType: "${params.payload.FailType}",
        MainNote: "${params.payload.MainNote}",
      ){
        Success
        Errors
        Messages
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.UPDATERESERVATIONANDCUSTOMER_CIF,
    { ...params.payload }
  );
}

export function* sendSMSInvite(params) {
  const idVerificationSkipped = params.payload.idVerificationSkipped ? params.payload.idVerificationSkipped : false;
  const sendSmsQuery = {
    query: `query{
      SendAddDriverSMSInvite(
          LastName: "${params.payload.lastName}", 
          ResNumber: "${params.payload.bookingNumber}",
          MobileNumber:"${params.payload.mobileNumber}",
          Brand:"${params.payload.brand}",
          Country:"${params.payload.country}",
          idVerificationSkipped: ${idVerificationSkipped}
          ){
          Success,
          Messages
           }
    }
  `,
};

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, sendSmsQuery)),
    types.SEND_SMS_INVITE,
    { ...params.payload }
  );
}


export function* frontdeskGetEstimate(params) {
  const updateQuery = {
    query: ` query {
      FrontdeskGetEstimate(
        ResNo: "${params.payload.resno}",
      ){
        Success,
        Error,
        Messages,
        Estimate{
          Total,
          Customer{
            OptionsCharges{
              Description,
              Quantity,
              Total
              SubTotal
            }
            TimeCharges{
              Description
              SubTotal
              Quantity
            }
          }
        }
      }
    }
   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.FRONTDESKRESESTIMATE,
    { ...params.payload }
  );
}

export function* searchAddress(params) {
  const updateQuery = {
    query: ` query {
      KleberDataValidation(
        Address: "${params.payload.address}",
        CountryCode : "${params.payload.countryCode}"
        Method:"${params.payload.method}",

      ){
        Success,
        Error,
        Status,
        International,
        SuggestionCountry,
        AddressResult{
          RecordId
          AddressLine,
          State,
          Locality,
          Postcode,
          Suburb,
          TownCityMailtown
          }
        }
      }   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.SEARCHADDRESS,
    { ...params.payload }
  );
}

export function* retrieveAddress(params) {
  const updateQuery = {
    query: ` query {
      KleberDataValidation(
        RecordId: "${params.payload.recordId}",
        Method:"${params.payload.method}",
        CountryCode: "${params.payload.countryCode}",
      ){
        Success,
        Error,
        Status,
        SuggestionCountry,
        AddressResult{
          AddressLine,
          State,
          Locality,
          Postcode,
          Suburb,
          AddressLine1,
          AddressLine2,
          LocalityCityTown,
          TownCityMailtown,
          StateProvince,
          District
          }
        }
      }   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.RETRIEVEADDRESS,
    { ...params.payload }
  );
}
export function* requestWindcaveHPP(params) {
  const updateQuery = {
    query: `query {
      WindcaveCreateSession(ResNo:"${params.payload.resNo}", Brand:"${params.payload.brand}", country:"${params.payload.country}" ){
          Success
          Url
        }
      }
  `,
  };

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.REQUEST_WINDCAVEHPP,
    { ...params.payload }
  );
}

function* windcaveStatus(params) {
  const graphqlQuery = {
    query: `query {
      WindcaveValidateCreditCard(ResNo:"${params.payload.resNo}", Brand:"${params.payload.brand}", , country:"${params.payload.country}"){
        Success
        ErrorMessage
        Windcave{
            sessionId
            resNumber
            status
            service
            action
            date
            transactions{
              card{
                  cardHolderName
              }
          }
          }
        }
      }
  `,
  };

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, graphqlQuery)),
    types.WINDCAVE_STATUS,
    { ...params.payload }
  );
}

export function* requestIdVerificationTransaction(params) {
  const generateTransactionQuery = {
    query: `query {
      IdVerification(
          IsAdditionalDriver:${params.payload.isAdditionalDriver},
          Channel: "${params.payload.channel}",
          FirstName: "${params.payload.firstName}", 
          Country: "${params.payload.country}",
          DLNumber: "${params.payload.dlNumber.toUpperCase().trim()}",
          Reference: "${params.payload.reference}",
          ResNumber: "${params.payload.resNumber}",
          RedirectUrlSuccess:"${params.payload.redirectUrlSuccess}",
          RedirectUrlExit:"${params.payload.redirectUrlExit}",
          RedirectUrlBack:"${params.payload.redirectUrlBack}"

          resNo: "${params.payload.resNo}",
          MainNote: "${params.payload.MainNote}",
          CustomerNumber: "${params.payload.CustomerNumber}",
          name: "${params.payload.name}",
          brand: "${params.payload.brand}",
          total: "${params.payload.total}",
          confNo: "${params.payload.confNo}",
          pickupDate: "${params.payload.pickupDate}",
          pickupTime: "${params.payload.pickupTime}",
          pickupLocation: "${params.payload.pickupLocation}",
          locationAddress: "${params.payload.locationAddress}",
          date: "${params.payload.date}",
          estimate:${santiseEstimates(params.payload.estimate)},
          otherid: "${params.payload.otherid}",
          prepaid:${params.payload.prepaid},
          email: "${params.payload.email}",
          phoneNumber: "${params.payload.phoneNumber}",
          emergencyPhoneNumber: "${params.payload.emergencyPhoneNumber}",
          scanDocPass: ${params.payload.scanDocPass},
          idVerificationSkipped: ${params.payload.idVerificationSkipped}
        ){
        Success
        TransactionId 
      }
    }
  `,
  };

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, generateTransactionQuery)),
    types.REQUEST_IDVERIFICATION_TRANSACTION,
    { ...params.payload }
  );
}

export function* requestIdVerificationStatus(params) {
  const transactionStatusQuery = {
    query: `query{
      IdVerificationQueryTransaction(
          TransactionId: "${params.payload.transactionId}" ){
              Success,
              Reason,
              CompletedAt,
              TransactionDetails{
                  Success,
                  TransactionStatus,
                  Email,
                  LastName,
                  FirstName,
                  StateCountry,
                  Address,
                  Suburb,
                  PostalCode,
                  DOB,
                  LicNo,
                  DateOfExpiry,
                  StateOfIssue,
                  Reference,
                  TransactionId,
                  VerifiedTime,
                  OverallResult,
                  Over21,
                  FaceMatch,
                  Liveness,
                  DVS,
                  DocumentVariant
                } 
              }
          }
  `,
  };

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, transactionStatusQuery)),
    types.REQUEST_IDVERIFICATION_STATUS,
    { ...params.payload }
  );
}

export function* getUpcomingOcrLabsOutage(params){
  const query = {
    query: `query{GetUpcomingOcrLabsOutage{
      start,
      end
    }}`
  }

  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, query)),
    types.GET_UPCOMING_OCRLABS_OUTAGE,
    { ...params.payload }
  );

}

export function* getBrandLocations(params) {
  const brand = params.payload.brand;
  const country = params.payload.country;
  // const reqUrl = `${apiGraphQLURI}?query={GetBrandLocationsLean{locationName, locationCode, brand}}`;
  const reqUrl = `${apiGraphQLURI}?query={GetBrandLocationsLean(brand:"${brand}", country:"${country}"){locationName, locationCode, brand}}`;
  const encodedURI = encodeURI(reqUrl);
  yield call(
    callApi,
    () => fetch(encodedURI),
    types.GET_BRAND_LOCATIONS,
  );
}

export function* watchCheckinRequest() {
  yield takeLatest(types.CHECKINAUTH, checkinAuth);
  yield takeLatest(types.CHECKIN_GENERIC, checkinGeneric);
  yield takeLatest(types.ADDITIONAL_DRIVER_AUTH, additionalDriverAuth);
  yield takeLatest(types.CHECKIN, checkin);
  yield takeLatest(types.SEARCHCUSTOMER, searchCustomer);
  yield takeLatest(types.UPDATERESERVATIONANDCUSTOMER, updateReservationAndCustomer);
  yield takeLatest(types.UPDATERESERVATIONANDCUSTOMER_CIF, updateReservationAndCustomerCIF);
  yield takeLatest(types.MANUAL_UPDATERESERVATIONANDCUSTOMER, manualUpdateReservationAndCustomerFromIdvResult);
  yield takeLatest(types.FRONTDESKRESESTIMATE, frontdeskGetEstimate);
  yield takeLatest(types.SENDNOTIFICATION, sendEmailNotification);
  yield takeEvery(types.SEARCHADDRESS, searchAddress);
  yield takeLatest(types.RETRIEVEADDRESS, retrieveAddress);
  yield takeLatest(types.FRONTDESKRESESTIMATE, frontdeskGetEstimate);
  yield takeLatest(types.SENDNOTIFICATION, sendEmailNotification);
  yield takeLatest(types.REQUEST_WINDCAVEHPP, requestWindcaveHPP);
  yield takeLatest(types.WINDCAVE_STATUS, windcaveStatus);
  yield takeLatest(types.CREATE_CUSTOMER, createNewCustomer);
  yield takeLatest(types.UPDATE_CUSTOMER, updateCustomer);
  yield takeLatest(types.MANUAL_CREATE_CUSTOMER, manualCreateNewCustomer);
  yield takeLatest(types.MANUAL_UPDATE_CUSTOMER, manualUpdateCustomer);
  yield takeLatest(types.REQUEST_IDVERIFICATION_TRANSACTION, requestIdVerificationTransaction);
  yield takeLatest(types.REQUEST_IDVERIFICATION_STATUS, requestIdVerificationStatus);
  yield takeLatest(types.SEND_SMS_INVITE, sendSMSInvite);
  yield takeLatest(types.GET_UPCOMING_OCRLABS_OUTAGE, getUpcomingOcrLabsOutage);
  yield takeLatest(types.GET_BRAND_LOCATIONS, getBrandLocations);
}
